<template>
  <v-content>
    <v-layout
      align-center
      justify-center
      fill-height
      @click="startScreenTouched"
    >
      <image-carousel :display-time="20" />
      <v-card flat tile color="#FFFFFFCC" class="heavy-shadow">
        <v-layout
          column
          align-stretch
          justify-center
          class="ma-0 text-xs-center"
        >
          <v-flex>
            <div
              id="fort-george-g-meade"
              class="grey--text text--darken-2 text-uppercase"
            >
              Fort George G. Meade
            </div>
          </v-flex>
          <v-flex>
            <div
              id="resiliency-services"
              class="secondary--text font-weight-bold"
            >
              <div id="resiliency">
                Resiliency
              </div>
              <div id="services">
                Services
              </div>
            </div>
          </v-flex>
          <v-flex>
            <v-btn
              depressed
              large
              block
              color="primary"
              class="ma-0 fma-block-button"
            >
              Touch to start
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card>
    </v-layout>
  </v-content>
</template>

<script>
import ImageCarousel from "@/components/ImageCarousel.vue";

export default {
  components: {
    ImageCarousel
  },
  methods: {
    startScreenTouched() {
      this.$router.push({ name: "Categories" });
    }
  }
};
</script>

<style scoped lang="less">
@import "../assets/global.less";

#fort-george-g-meade {
  font-size: 18px;
  letter-spacing: 4px;
  margin-top: 10px;
  margin-bottom: 4px;
  margin-left: 20px;
  margin-right: 20px;
}

#resiliency-services {
  font-size: 64px;
  #resiliency {
    margin-top: -20px;
    margin-bottom: -40px;
    margin-left: 20px;
    margin-right: 20px;
  }
  #services {
    margin-top: -40px;
    margin-bottom: 0px;
    margin-left: 20px;
    margin-right: 20px;
  }
}
</style>
